<script>
import { ToolSuggestion, ToolCategory } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      redirectRoute: { name: 'Suggestion List' }
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'Nazwa',
          modelPath: [this, 'form', 'name']
        }),
        new fields.ForeignKey({
          label: 'Kategoria',
          modelPath: [this, 'form', 'category'],
          labelField: 'title_pl',
          valueField: 'id',
          service: ToolCategory
        }),
        new fields.Input({
          label: 'Email',
          modelPath: [this, 'form', 'email']
        })
      ]
    }
  },
  computed: {
    service() {
      return ToolSuggestion
    }
  }
}
</script>
